export const statesOfUSA = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const contractsForNavbar = {
  "Real Estate": {
    heading: "Real Estate",
    description:
      "All of our legal contracts and documents are drafted and regularly updated by attorneys licensed in their respective jurisdictions, paralegals, or subject matter experts. Save your hard-earned money and time with Legal Templates.",
    subCategoryData: {
      "Home Ownership": [
        {
          _id: "64d4e634309bdbfe4b323e06",
          name: "Moving Checklist",
          categories: "Real Estate",
          subcategories: "Home Ownership",
        },
        {
          _id: "64d4e634309bdbfe4b323e04",
          name: "Land Purchase Agreement",
          categories: "Real Estate",
          subcategories: "Home Ownership",
        },
        {
          _id: "64d4e634309bdbfe4b323e07",
          name: "Property Disclosure Statement",
          categories: "Real Estate",
          subcategories: "Home Ownership",
        },
        {
          _id: "64d4e634309bdbfe4b323e01",
          name: "Deed of Trust",
          categories: "Real Estate",
          subcategories: "Home Ownership",
        },
      ],
      Landlords: [
        {
          _id: "64d4e634309bdbfe4b323de9",
          name: "Land Lease Agreement",
          categories: "Real Estate",
          subcategories: "Landlords",
        },
        {
          _id: "64d4e634309bdbfe4b323de8",
          name: "Eviction Notice",
          categories: "Real Estate",
          subcategories: "Landlords",
        },
        {
          _id: "64d4e634309bdbfe4b323de6",
          name: "Commercial Lease Application",
          categories: "Real Estate",
          subcategories: "Landlords",
        },
        {
          _id: "64d4e634309bdbfe4b323de4",
          name: "Commercial Lease Agreement",
          categories: "Real Estate",
          subcategories: "Landlords",
        },
      ],
      Tenants: [
        {
          id: "64d4e634309bdbfe4b323e0d",
          name: "Early Lease Termination Letter",
          categories: "Real Estate",
          subcategories: "Tenants",
        },
        {
          id: "64d4e634309bdbfe4b323e0e",
          name: "Lease Termination Letter",
          categories: "Real Estate",
          subcategories: "Tenants",
        },
        {
          id: "64d4e634309bdbfe4b323e13",
          name: "Sublease Agreement",
          categories: "Real Estate",
          subcategories: "Tenants",
        },
        {
          id: "64d4e634309bdbfe4b323e0f",
          name: "Moving Checklist",
          categories: "Real Estate",
          subcategories: "Tenants",
        },
      ],
    },
    sideColor: "bg-red-100/50"
  },

  "Personal Family": {
    heading: "Personal Family",
    description:
      "All of our legal contracts and documents are drafted and regularly updated by attorneys licensed in their respective jurisdictions, paralegals, or subject matter experts. Save your hard-earned money and time with Legal Templates.",
    subCategoryData: {
      "Personal Property": [
        {
          id: "64d4e634309bdbfe4b323e4c",
          name: "Dirt Bike Bill of Sale",
          categories: "Personal Family",
          subcategories: "Personal Property",
        },
        {
          id: "64d4e634309bdbfe4b323e47",
          name: "As-Is Bill of Sale",
          categories: "Personal Family",
          subcategories: "Personal Property",
        },
        {
          id: "64d4e634309bdbfe4b323e4a",
          name: "Boat Bill of Sale",
          categories: "Personal Family",
          subcategories: "Personal Property",
        },
        {
          id: "64d4e634309bdbfe4b323e51",
          name: "Horse Bill of Sale",
          categories: "Personal Family",
          subcategories: "Personal Property",
        },
      ],
      "Family Matters": [
        {
          _id: "64d4e634309bdbfe4b323e27",
          name: "Pet Custody Agreement",
          categories: "Personal Family",
          subcategories: "Family Matters",
        },
        {
          _id: "64d4e634309bdbfe4b323e21",
          name: "Child Medical Consent",
          categories: "Personal Family",
          subcategories: "Family Matters",
        },
        {
          _id: "64d4e634309bdbfe4b323e26",
          name: "Parenting Plan",
          categories: "Personal Family",
          subcategories: "Family Matters",
        },
        {
          _id: "64d4e634309bdbfe4b323e23",
          name: "Child Travel Consent",
          categories: "Personal FamilyPersonal Family",
          subcategories: "Family Matters",
        },
      ],
      "General Legal Matters": [
        {
          _id: "64d4e634309bdbfe4b323e61",
          name: "Affidavit of Identity",
          categories: "Personal Family",
          subcategories: "General Legal Matters",
        },
        {
          _id: "64d4e634309bdbfe4b323e60",
          name: "Affidavit of Heirship",
          categories: "Personal Family",
          subcategories: "General Legal Matters",
        },
        {
          _id: "64d4e634309bdbfe4b323e5e",
          name: "Affidavit of Death",
          categories: "Personal Family",
          subcategories: "General Legal Matters",
        },
        {
          _id: "64d4e634309bdbfe4b323e5f",
          name: "Affidavit of Domicile",
          categories: "Personal Family",
          subcategories: "General Legal Matters",
        },
      ],
      "Estate Planning": [
        {
          _id: "64d4e634309bdbfe4b323e16",
          name: "Do Not Resuscitate",
          categories: "Personal Family",
          subcategories: "Will & Estate Planning",
        },
        {
          _id: "64d4e634309bdbfe4b323e18",
          name: "Last Will and Testament",
          categories: "Personal Family",
          subcategories: "Will & Estate Planning",
        },
        {
          _id: "64d4e634309bdbfe4b323e19",
          name: "Limited (Special) Power of Attorney",
          categories: "Personal Family",
          subcategories: "Will & Estate Planning",
        },
        {
          _id: "64d4e634309bdbfe4b323e14",
          name: "Advance Directive",
          categories: "Personal Family",
          subcategories: "Will & Estate Planning",
        },
      ],
    },
    sideColor: "bg-blue-100/50"

  },

  Business: {
    heading: "Business",
    description:
      "All of our legal contracts and documents are drafted and regularly updated by attorneys licensed in their respective jurisdictions, paralegals, or subject matter experts. Save your hard-earned money and time with Legal Templates.",
    subCategoryData: {
      "Service": [
        {
          id: "64d4e634309bdbfe4b323eca",
          name: "Contingency Fee Agreement",
          categories: "Business",
          subcategories: "Service",
        },
        {
          id: "64d4e634309bdbfe4b323ecb",
          name: "Freelance Contract",
          categories: "Business",
          subcategories: "Service",
        },
        {
          id: "64d4e634309bdbfe4b323ecc",
          name: "Independent Contractor Agreement",
          categories: "Business",
          subcategories: "Service",
        },
        {
          id: "64d4e634309bdbfe4b323ecd",
          name: "Supply Agreement",
          categories: "Business",
          subcategories: "Service",
        },
      ],
      "Business Formation": [
        {
          _id: "64d4e634309bdbfe4b323e6a",
          name: "Business Plan",
          categories: "Business",
          subcategories: "Business Formation",
        },
        {
          _id: "64d4e634309bdbfe4b323e6d",
          name: "Founders' Agreement",
          categories: "Business",
          subcategories: "Business Formation",
        },
        {
          _id: "64d4e634309bdbfe4b323e6c",
          name: "Corporate Bylaws",
          categories: "Business",
          subcategories: "Business Formation",
        },
        {
          _id: "64d4e634309bdbfe4b323e6e",
          name: "LLC Operating Agreement",
          categories: "Business",
          subcategories: "Business Formation",
        },
      ],
      "Business Operations": [
        {
          _id: "64d4e634309bdbfe4b323e79",
          name: "Business Contract",
          categories: "Business",
          subcategories: "Business Operations",
        },
        {
          _id: "64d4e634309bdbfe4b323e7a",
          name: "Business Loan Agreement",
          categories: "Business",
          subcategories: "Business Operations",
        },
        {
          _id: "64d4e634309bdbfe4b323e78",
          name: "Business Continuity Plan",
          categories: "Business",
          subcategories: "Business Operations",
        },
        {
          _id: "64d4e634309bdbfe4b323e7b",
          name: "Business Proposal",
          categories: "Business",
          subcategories: "Business Operations",
        },
      ],
      Employment: [
        {
          _id: "64d4e634309bdbfe4b323ec5",
          name: "Telecommuting Agreement",
          categories: "Business",
          subcategories: "Employment",
        },
        {
          _id: "64d4e634309bdbfe4b323eb9",
          name: "Harassment Policy",
          categories: "Business",
          subcategories: "Employment",
        },
        {
          _id: "64d4e634309bdbfe4b323e9f",
          name: "Caregiver Agreement",
          categories: "Business",
          subcategories: "Employment",
        },
        {
          _id: "64d4e634309bdbfe4b323ea4",
          name: "Dentist Employment Agreement",
          categories: "Business",
          subcategories: "Employment",
        },
      ],
    },
    sideColor: "bg-yellow-100/50"

  },



};


export const legalTemplatesMapping = {


  "motor-vehicle-power-of-attorney-form": "712",
  "car-accident-release-of-liability-form": "486",
  "daycare-contract-template": "455",
  "debt-collections-letter": "270",
  "recommendation-letter-for-scholarship": "756",
  "hunting-lease-agreement": "870",
  "landlord-recommendation-letter-for-a-tenant": "802",
  "one-week-notice-letter": "898",
  "motor-vehicle-power-of-attorney-form": "712",
  "triple-net-(nnn)-lease-agreement": "786",
  "real-estate-power-of-attorney-form": "711",
  "pennsylvania-standard-residential-lease-agreementorm": "537",
  "rental-monthly-rent-invoice": "296",
  "registered-nurse-rn-letter-of-recommendation": "763",
  "vehicle-towing-receipt-template": "375",
  "personal-training-waiver-and-release-form": "484",
  "remodeling-contract-template": "21",
  "mortgage-pre-approval-letter": "793",
  "registered-nurse-letter-of-recommendation-template": "655",
  "painting-invoice-template": "296",
  "cleaning-service-contract": "455",
  "photography-contract": "455",
  "babysitter-contract-template": "21",
  "mba-letter-of-recommendation-template": "760",
  "corporate-resolution-form": "588",
  "concrete-subcontractor-agreement": "682",
  "character-reference-letter-for-court": "741",
  "california-3-day-notice-to-quit-form-%7C-non-payment-of-rent": "367",
  "moving-contract": "455",
  "letter-of-intent-to-purchase-a-business": "302",
  "free-bill-of-sale": "140",
  "general-financial-power-of-attorney": "940",
  "land-purchase-agreement": "408",
  "real-estate-purchase-agreement-addendum": "408",
  "roofing-contract": "682",
  "landscaping-contract": "455",
  "employee-write-up-forms": "678",
  "photo-licensing-agreement": "459",
  "painting-contract": "455",
  "plumbing-contract": "455",
  "employee-warning-notice": "678",
  "board-resignation-letter-template": "902",
  "interior-design-services-contract": "455",
  "model-services-contract": "455",
  "affidavit-of-title": "416",
  "prenuptial-agreement": "4",
  "refund-demand-letter": "617",
  "transfer-on-death-deed-form": "660",
  "character-reference-letter-for-immigration": "736",
  "separation-agreement": "359",
  "affidavit-of-identity/": "414",
  "early-lease-termination-letter/": "526",
  "affidavit-of-heirship": "415",
  "response-to-demand-letter": "623",
  "promissory-note": "540",
  "horse-bill-of-sale": "25",
  "month-to-month-rental-agreement": "472",
  "codicil-to-will": "353",
  "affidavit-of-identity": "414",
  "unpaid-wages-demand-letter": "619",
  "as-is-bill-of-sale": "628",
  "small-claims-demand-letter": "622",
  "prenuptial-agreement": "4",
  "affidavit-of-title": "416",
  "atv-bill-of-sale": "140",
  "affidavit-form": "522",
  "rv-bill-of-sale": "140",
  "utv-bill-of-sale": "140",
  "small-estate-affidavit": "515",
  "tractor-bill-of-sale": "140",
  "child-support-modification": "426",
  "vehicle-bill-of-sale": "140",
  "snowmobile-bill-of-sale": "140",
  "even-trade-bill-of-sale": "639",
  "semi-truck-bill-of-sale": "140",
  "notary-acknowledgment": "558",
  "scooter-moped-bill-of-sale": "140",
  "personal-property-demand-letter": "616",
  "debt-validation-letter": "591",
  "affidavit-of-domicile": "419",
  "child-support-demand-letter": "635",
  "corporate-resolution": "588",
  "notice-of-contract-termination": "573",
  "rental-application": "396",
  "notice-of-rent-increase": "16",
  "construction-contract-agreement": "351",
  "child-travel-consent": "547",
  "cease-and-desist-letter": "138",
  "dirt-bike-bill-of-sale": "140",
  "land-purchase-agreement/": "612",
  "rental-agreement/": "537",
  "quitclaim-deed": "267",
  "employee-evaluation-form/": "572",
  "employment-rejection-letter/": "571",
  "employment-offer-letter": "562",
  "work-from-home-policy/": "580",
  "social-media-policy/": "595",
  "loan-agreement": "141",
  "last-will-and-testament": "460",
  "rent-receipt": "610",
  "firearm-bill-of-sale": "266",
  "golf-cart-bill-of-sale": "140",
  "boat-bill-of-sale": "23",
  "breach-of-contract-demand-letter": "636",
  "child-medical-consent": "17",
  "confidential-information--inventions-assignment-ciia-agreement/": "575",
  "cohabitation-agreement": "258",
  "rent-to-own-agreement": "537",
  "gifted-car-bill-of-sale": "140",
  "gift-affidavit": "424",
  "affidavit-of-residence": "422",
  "trailer-bill-of-sale": "535",
  "mobile-home-bill-of-sale": "140",
  "trust-amendment": "593",
  "notarized-bill-of-sale": "629",
  "i-owe-you-iou": "11",
  "motorcycle-bill-of-sale": "24",
  "business-bill-of-sale": "645",
  "do-not-resuscitate": "495",
  "jet-ski-bill-of-sale": "638",
  "pet-care-agreement": "22",
  "revocable-living-trust": "461",
  "lawnmower-bill-of-sale": "140",
  "livestock-bill-of-sale": "630",
  "affidavit-of-paternity": "585",
  "living-will-health-care-directive": "939",
  "postnuptial-agreement": "399",
  "parenting-plan": "360",
  "pet-custody-agreement": "418",
  "medical-records-release-form": "247",
  "limited-special-power-of-attorney": "563",
  "furniture-bill-of-sale": "79",
  "revocation-of-power-of-attorney": "12",
  "affidavit-of-death": "420",
  "durable-power-of-attorney": "940",
  "birth-plan": "556",
  "demand-letter-for-payment": "427",
  "self-proving-affidavit": "594",
  "aircraft-bill-of-sale": "140",
  "personal-injury-payment-demand-letter": "618",
  "cat-bill-of-sale-template": "631",
  "power-of-attorney": "940",
  "medical-power-of-attorney": "281",
  "bicycle-bill-of-sale": "140",
  "equipment-lease": "560",
  "texas-medical-power-of-attorney": "288",
  "springing-power-of-attorney": "713",
  "divorce-agreement": "358",
  "social-security-change-in-information": "553",
  "financial-affidavit": "423",
  "early-lease-termination-letter": "526",
  "pet-addendum-to-a-lease-agreement": "134",
  "notice-to-vacate-letter": "941",
  "short-term-rental-agreement": "537",
  "parking-space-lease-agreement": "537",
  "lease-extension-agreement": "354",
  "late-rent-notice": "445",
  "rental-application-rejection-letter": "609",
  "commercial-lease-application": "583",
  "rental-inspection-checklist": "446",
  "condominium-lease-agreement": "537",
  "lease-amendment": "354",
  "mortgage-deed": "310",
  "warranty-deed": "260",
  "employment-income-verification-letter": "498",
  "background-check-authorization": "603",
  "lease-termination-letter": "20",
  "colorado-standard-residential-lease-agreement": "537",
  "rental-application-approval-letter": "607",
  "property-management-agreement": "403",
  "sublease-agreement": "818",
  "moving-checklist": "432",
  "eviction-notice": "941",
  "deed-in-lieu-of-foreclosure": "697",
  "real-estate-purchase-agreement-amendment": "614",
  "commercial-lease-agreement-addendum": "611",
  "deed-of-trust": "307",
  "commercial-lease-agreement": "264",
  "escrow-holdback-agreement-addendum": "627",
  "property-disclosure-statement": "633",
  "rental-agreement": "537",
  "roommate-agreement": "137",
  "triple-net-nnn-lease-agreement": "786",
  "real-estate-purchase-agreement": "608",
  "texas-residential-lease-agreement": "537",
  "smoking-lease-addendum": "261",
  "standard-residential-lease-agreement": "537",
  "farm-purchase-agreement": "613",
  "california-month-to-month-lease-agreement": "472",
  "return-to-work-letter": "658",
  "payment-plan-agreement": "552",
  "hold-harmless-indemnity-agreement": "388",
  "employment-termination-letter": "561",
  "salary-verification-letter": "498",
  "cease-and-desist-harassment-letter": "268",
  "release-of-liability-waiver": "484",
  "electrical-contract": "455",
  "construction-contract-agreement": "351",
  "demotion-letter": "667",
  "business-purchase-agreement": "257",
  "homeschool-letter-of-intent": "803",
  "handyman-contract": "455",
  "cease-and-desist-defamation-letter": "271",
  "5050-business-partnership-agreement": "298",
  "buy-sell-agreement": "410",
  "commission-agreement": "669",
  "amendment-to-llc-operating-agreement": "409",
  "affidavit-of-service": "411",
  "caregiver-agreement": "625",
  "flooring-services-agreement": "455",
  "mechanics-lien": "433",
  "photo-release-form": "279",
  "confidential-information--inventions-assignment-ciia-agreement": "575",
  "corporate-minutes": "597",
  "home-improvement-contract": "455",
  "letter-of-intent": "302",
  "employment-application": "559",
  "employee-disciplinary-action-form": "649",
  "temporary-employment-contract": "135",
  "articles-of-incorporation": "942",
  "employee-emergency-contact-form": "643",
  "assignment-agreement": "626",
  "immediate-letter-of-resignation": "894",
  "real-estate-partnership-agreement": "298",
  "stock-certificate": "195",
  "assignment-of-partnership-interest": "404",
  "employee-reprimand-form": "648",
  "contingency-fee-agreement": "637",
  "food-truck-business-plan": "254",
  "llc-operating-agreement": "400",
  "catering-contract": "455",
  "snow-removal-contract": "455",
  "corporate-bylaws": "511",
  "employee-complaint-form": "647",
  "emergency-action-plan": "592",
  "non-compete-agreement": "421",
  "subcontractor-agreement": "682",
  "cease-and-desist-copyright-infringement-notice": "269",
  "workplace-incident-report": "671",
  "dj-disc-jockey-contract": "455",
  "single-member-llc-operating-agreement": "523",
  "independent-contractor-agreement": "21",
  "small-business-partnership-agreement": "298",
  "employment-contract": "135",
  "business-contract": "455",
  "employee-counseling-form": "644",
  "toll-manufacturing-agreement": "428",
  "furlough-letter": "665",
  "interview-candidate-non-disclosure-agreement-nda": "449",
  "partnership-agreement": "298",
  "family-member-proof-of-residency-letter": "422",
  "vehicle-private-sale-receiptr": "375",
  "501-c-3-donation-receipt": "924",
  "sales-receipt": "375",
  "lease-agreement-addendum": "606",
  "general-(personal-property)-bill-of-sale-form": "81",
  "land-lease-agreement": "470",
  "receipt-book-template-%7C-print-3-receipts-per-page": "375",
  "cell-phone-policy": "672"
}